import React from 'react';
import { injectIntl } from '../../Utils/reactIntlCompat';
import PropTypes from 'prop-types';
import { Button, Popover, Typography, Box } from '@mui/material';

const ConfirmPopup = function ConfirmPopup({
  id = 'confirm-popup',
  open = false,
  close = () => {},
  anchorEl = null,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  confirmText = null,
  handleConfirm = () => {},
  intl, //i18n for translations
}) {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={close}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      <div
        style={{
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '300px',
          height: '150px',
        }}
      >
        <Typography variant="subtitle1" sx={{
          alignSelf: "center"
        }}>
          {confirmText || intl.messages.GENERAL_CONFIRMTEXT}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Button onClick={close} variant="text" color="error">
            {intl.messages.CANCEL}
          </Button>
          <Button
            onClick={(e) => {
              close(e);
              handleConfirm(e);
            }}
            variant="text"
          >
            {intl.messages.CONFIRM}
          </Button>
        </Box>
      </div>
    </Popover>
  );
};

ConfirmPopup.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  close: PropTypes.func,
  anchorEl: PropTypes.element,
  anchorOrigin: PropTypes.object,
  transformOrigin: PropTypes.object,
  confirmText: PropTypes.string,
  intl: PropTypes.object.isRequired,
  handleConfirm: PropTypes.func,
};

export default injectIntl(ConfirmPopup);
